export default __webpack_public_path__ + "static/media/slider4.605d0c42.jpeg";